import { createFileRoute, Outlet, redirect, useNavigate, useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { SiteLayout } from "@/components/site/site-layout";
import { useAuth } from "@/hooks/use-auth";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async () => {
    if (typeof window === "undefined") return;
    const { data } = await supabase.auth.getSession();
    if (!data.session) {
      throw redirect({ to: "/login" });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isAdmin = pathname === "/admin" || pathname.startsWith("/admin/");

  useEffect(() => {
    if (!loading && !user) {
      navigate({ to: "/login", replace: true });
    }
  }, [loading, navigate, user]);

  if (loading || !user) {
    if (isAdmin) {
      return (
        <div className="mx-auto max-w-6xl px-4 py-16 text-sm text-muted-foreground">
          Loading your account…
        </div>
      );
    }
    return (
      <SiteLayout>
        <div className="mx-auto max-w-6xl px-4 py-16 text-sm text-muted-foreground">
          Loading your account…
        </div>
      </SiteLayout>
    );
  }

  if (isAdmin) {
    return <Outlet />;
  }

  return (
    <SiteLayout>
      <Outlet />
    </SiteLayout>
  );
}

